import ImageEdit from "./ImageEdit";

export default ImageEdit;
